module.exports = __webpack_public_path__ + "static/media/yrp.6e01a399.jpg";